import { restClient } from '@/Core/Services/RestClientService'
import type { InviteDriverPayload } from '../Contracts/InvitationPayload'

/**
 * POST /services/users/driver-invitation — invite a new driver.
 *
 * Same violations contract as InviteUserTask.
 */
export const InviteDriverTask = async (payload: InviteDriverPayload): Promise<any> => {
    return restClient.post('/services/users/driver-invitation', { json: payload })
}
